// Copyright (C) 2023 Cochise Ruhulessin
//
// All rights reserved. No warranty, explicit or implicit, provided. In
// no event shall the author(s) be liable for any claim or damages.
//
// Unless required by applicable law or agreed to in writing, software
// distributed under the License is distributed on an "AS IS" BASIS,
// WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
import * as phonenumbers from "google-libphonenumber"
import { IFieldValidator } from "./IFieldValidator"


interface PhonenumberValidatorArguments {
  required?: boolean
  errorMessages?: {[key: string]: string}
}


const phoneUtil = phonenumbers.PhoneNumberUtil.getInstance();



export class PhonenumberValidator implements IFieldValidator {
  private errorMessages: {[key: string]: string}
  private required: boolean

  constructor(opts?: PhonenumberValidatorArguments) {
    const kwargs = opts || {}
    this.errorMessages = kwargs.errorMessages || {
      invalid: "INVALID"
    }
    this.required = !!kwargs.required
  }

  getErrorMessage(code: string): string {
    return this.errorMessages[code] || this.errorMessages["invalid"]
  }

  validate(value: string | null | undefined): string[] {
    const errors: string[] = []
    if (!value && this.required) {
      return [this.getErrorMessage("required")]
    }
    if (!!value) {
      if (!value.startsWith("+")) {
        errors.push(this.getErrorMessage("mustStartWithPlus"))
      }
      try {
        const p = phoneUtil.parse(value)
        if (!phoneUtil.isValidNumber(p)) {
          errors.push(this.getErrorMessage("invalid"))
        }
      } catch {
        errors.push(this.getErrorMessage("invalid"))
      }
    }
    return errors
  }
}